import Icon, { IconNames } from 'components/Icon';

type popUpTypes = 'TAGS' | 'COPY' | 'IMPACT';
interface ImpactScoreHelperProps {
  setPopupType: (type: popUpTypes) => void;
  setIsPopupOpen: (isOpen: boolean) => void;
}

const ImpactScoreHelper = ({ setPopupType, setIsPopupOpen }: ImpactScoreHelperProps) => {
  return (
    <>
      <div className="row justify-between">
        <span className="body-text color-black">Recipient</span>
        <div className="row">
          <span className="body-text color-black" style={{ marginRight: '8px' }}>
            Impact Score
          </span>
          <button
            className="impact-score-helper"
            type="button"
            aria-label="Learn about Impact Score"
            onClick={() => {
              setPopupType('IMPACT');
              setIsPopupOpen(true);
            }}
          >
            <Icon name={IconNames.HelpCircle} size={20} />
          </button>
        </div>
      </div>
    </>
  );
};

export default ImpactScoreHelper;
